import { getIconPathFromTokenSymbol } from '@/utils';
import { HStack, Image, Skeleton } from '@chakra-ui/react';

export type TokenIconListProps = {
  tokens: {
    symbol: string;
  }[];
  loading: boolean;
};

export const TokenIconList = ({ tokens, loading }: TokenIconListProps) => (
  <Skeleton loading={loading}>
    <HStack gap={0} w="full">
      {tokens.length && <Image src={getIconPathFromTokenSymbol(tokens[0].symbol)} boxSize={6} />}
      {tokens.slice(1).map(({ symbol }) => (
        <Image src={getIconPathFromTokenSymbol(symbol)} boxSize={6} ml="-14px" key={symbol} />
      ))}
    </HStack>
  </Skeleton>
);
